import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { makeVar, useReactiveVar } from '@apollo/client';
import { Dialog } from '@totalsoft/rocket-ui';
import { ExportContainer } from 'components/common/export/ExportContainer';
import IconButton from 'components/common/buttons/IconButton';
import { useSimpleError } from 'hooks';
import { PARTNER_TYPES_QUERY } from '../queries';

const partnerTypesExportModalOpenVar = makeVar(false);

const PartnerTypeExportComponent = () => {
  const { t } = useTranslation();
  const open = useReactiveVar(partnerTypesExportModalOpenVar);
  const showError = useSimpleError();

  const setOpen = useCallback(value => () => partnerTypesExportModalOpenVar(value), []);

  const options = useMemo(
    () => ({
      queryOptions: {
        query: PARTNER_TYPES_QUERY,
        name: 'partnerTypes',
        onError: showError
      }
    }),
    [showError]
  );

  return (
    <>
      <IconButton type='download' variant='contained' size='medium' onClick={setOpen(true)} />
      <Dialog
        id='partner-types-export-dialog'
        open={open}
        onClose={setOpen(false)}
        maxWidth='xs'
        title={t('ListBrowser.SelectExportType')}
        sx={{ '& .MuiDialogContent-root': { pb: 0 } }}
        closeButtonProps={{ sx: { display: 'none' } }}
        content={<ExportContainer options={options} onExport={setOpen(false)} onCancel={setOpen(false)} />}
      />
    </>
  );
};

export default PartnerTypeExportComponent;
